import { de, type Recipe } from "@ainkauf/core";

/**
 * Woher ein Rezept kommt: ein kleines Kennzeichen "Spaisekammer" und, wenn es
 * jemand anderes erfasst hat, "von Mama".
 *
 * Eigene Rezepte tragen nichts. Die Herkunft ist nur dann eine Information,
 * wenn sie von der Regel abweicht.
 */
export function RecipeOrigin({ recipe }: { recipe: Pick<Recipe, "source" | "owner_name"> }) {
  if (recipe.source !== "spaisekammer") return null;

  return (
    <span className="mt-0.5 flex flex-wrap items-center gap-1.5" data-testid="recipe-origin">
      <span className="rounded-full bg-paper-2 px-2 py-0.5 text-[11px] font-bold uppercase tracking-[0.06em] text-ink-3">
        {de.spaisekammer.origin}
      </span>
      {recipe.owner_name !== null && recipe.owner_name.length > 0 && (
        <span className="text-xs text-ink-3" data-testid="recipe-owner">
          {de.spaisekammer.by(recipe.owner_name)}
        </span>
      )}
    </span>
  );
}
